const TokenKey = "admin";

function readCookie(name) {
  const match = document.cookie.match(
    new RegExp(
      "(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"
    )
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

function writeCookie(name, value, days) {
  let expires = "";
  if (typeof days === "number") {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name +
    "=" +
    encodeURIComponent(value) +
    expires +
    "; path=/";
}

function removeCookie(name) {
  document.cookie =
    name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

export function getToken() {
  return readCookie(TokenKey);
}

export function setToken(token) {
  return writeCookie(TokenKey, token, 999);
}

export function removeToken() {
  return removeCookie(TokenKey);
}
